"use client";

import NewLocationDot from "components/icons-svg/NewLocationDot";
import SearchIcon from "components/icons-svg/SearchIcon";
import MobileSearchDrawer from "components/searchBar/mobile-tablet-view/MobileSearchDrawer";
import { useAppDispatch } from "stores/hooks";
import { initialState, markLocalSearch } from "stores/local-search/localSearchSlice";
import { markSearchFlow } from "stores/ui/uiSlice";
import { useMediaQuery } from "utils/hooks/useMediaQuery";
const MobileSearchBoxLogicNew = ({
  isOpen,
  onClose,
  onToggle,
  pageOrigin,
  className = "md:hidden",
  promptLabel = "Where to?"
}: {
  isOpen: boolean;
  onToggle: () => void;
  onClose: () => void;
  pageOrigin: string;
  className?: string;
  promptLabel?: string;
}) => {
  const dispatch = useAppDispatch();
  const [isDesktop] = useMediaQuery("(min-width: 992px)");
  const handleClick = () => {
    onToggle(); // Toggles the open/close state of the search box
    dispatch(markSearchFlow({
      currentSearchTab: "location"
    }));
    dispatch(markLocalSearch(initialState)); // Reset local search state
  };
  return <div className='relative w-full' data-sentry-component="MobileSearchBoxLogicNew" data-sentry-source-file="MobileSearchBoxLogicNew.tsx">
      {/* Search drawer that only appears on mobile & tablet screens */}
      {isOpen && !isDesktop && <MobileSearchDrawer isOpen={isOpen} onClose={onClose} pageOrigin={pageOrigin} />}

      <button onClick={handleClick} className={`relative h-[46px] w-full overflow-hidden text-ellipsis whitespace-nowrap rounded-full bg-offWhite pl-[42px] pr-[52px] text-left text-base font-semibold text-brand-dark ${className} `}>
        <div className='absolute bottom-1 left-5 top-3 flex h-5 w-5 items-center justify-center'>
          <NewLocationDot className='h-5 w-4 fill-[#8D91A5]' data-sentry-element="NewLocationDot" data-sentry-source-file="MobileSearchBoxLogicNew.tsx" />
        </div>
        {promptLabel}
        <div className='pointer-events-none absolute right-2 top-[7px] flex h-[32px] w-[32px] items-center justify-center rounded-full bg-accent-500 text-white'>
          <SearchIcon className='h-[18px] w-3.5' data-sentry-element="SearchIcon" data-sentry-source-file="MobileSearchBoxLogicNew.tsx" />
        </div>
      </button>
    </div>;
};
export default MobileSearchBoxLogicNew;